import type { ParsedReplySuggestion, ReplySuggestionResponse } from 'types';

const REASON_SEPARATOR = '\n\nWhy this reply:';
const DRAFT_PREFIX = /^Suggested reply:\s*/i;

export const parseReplySuggestion = (response: ReplySuggestionResponse): ParsedReplySuggestion => {
    const isEmpty =
        response.model === null &&
        response.latest_message === null &&
        response.latest_question === null;
    const normalizedSuggestion = response.suggestion.replace(/\r\n/g, '\n').trim();

    if (isEmpty) {
        return {
            draft: '',
            hint: normalizedSuggestion,
            isEmpty: true,
        };
    }

    const separatorIndex = normalizedSuggestion.indexOf(REASON_SEPARATOR);
    const rawDraft =
        separatorIndex === -1
            ? normalizedSuggestion
            : normalizedSuggestion.slice(0, separatorIndex);
    const hint =
        separatorIndex === -1
            ? ''
            : normalizedSuggestion.slice(separatorIndex + REASON_SEPARATOR.length).trim();

    return {
        draft: rawDraft.replace(DRAFT_PREFIX, '').trim(),
        hint,
        isEmpty: false,
    };
};
